import { useRef, useState } from "react";
import { toast } from "sonner";
import { Camera, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { PushPreferences } from "@/components/PushPanel";
import { useTalk, TkAvatar, tkErr } from "./TalkLayout";

export default function TalkMe() {
  const { me, reloadMe } = useTalk();
  const p = me.profile;
  const [form, setForm] = useState({ username: p.username, display_name: p.display_name, status: p.status });
  const [busy, setBusy] = useState(false);
  const [up, setUp] = useState(false);
  const fileRef = useRef(null);
  const save = async () => {
    setBusy(true);
    try { await api.patch("/talk/me", form); await reloadMe(); toast.success("Profile saved"); } catch (e) { tkErr(e); }
    setBusy(false);
  };
  const avatar = async (f) => {
    if (!f) return;
    setUp(true);
    const fd = new FormData(); fd.append("file", f);
    try { await api.post("/talk/me/avatar", fd); await reloadMe(); } catch (e) { tkErr(e); }
    setUp(false);
  };
  const field = (k, label, max) => (
    <label className="block">
      <span className="mono text-[10px] uppercase tracking-widest text-white/50">{label}</span>
      <input value={form[k]} maxLength={max} onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`talk-me-${k}`}
        className="mt-1 w-full bg-white/5 border border-white/10 rounded-2xl px-4 py-3 outline-none focus:border-[#FF2BD6]" />
    </label>
  );
  return (
    <div className="space-y-6" data-testid="talk-me">
      <div className="flex items-center gap-4">
        <button onClick={() => fileRef.current.click()} className="relative" data-testid="talk-me-avatar-btn" aria-label="Change photo">
          <TkAvatar p={p} size={84} />
          <span className="absolute -bottom-1 -right-1 w-8 h-8 rounded-full bg-[#FF2BD6] text-black flex items-center justify-center">{up ? <Loader2 className="w-4 h-4 animate-spin" /> : <Camera className="w-4 h-4" />}</span>
        </button>
        <input ref={fileRef} type="file" accept="image/*" hidden onChange={(e) => avatar(e.target.files[0])} data-testid="talk-me-avatar-input" />
        <div>
          <div className="font-heading font-black text-2xl">{p.display_name}</div>
          <div className="mono text-sm text-white/50">@{p.username}</div>
          <div className="text-xs text-white/40 mt-1">Friends find you by this username.</div>
        </div>
      </div>
      <div className="space-y-3">
        {field("display_name", "Display name", 40)}
        {field("username", "Username", 20)}
        {field("status", "Status", 120)}
        <button onClick={save} disabled={busy} data-testid="talk-me-save" className="bg-[#FF2BD6] text-black font-black rounded-full px-6 py-3 disabled:opacity-50">{busy ? "Saving…" : "Save profile"}</button>
      </div>
      <label className="flex items-center gap-3 rounded-3xl border border-white/10 p-4 cursor-pointer" data-testid="talk-me-leaderboard">
        <div className="flex-1"><div className="font-bold">Show me on the weekly gift leaderboard</div><div className="text-xs text-white/50">Off by default. When on, your weekly gift totals are public in the Top tab.</div></div>
        <input type="checkbox" className="w-5 h-5 accent-[#FFE300]" checked={!!p.leaderboard_opt_in} data-testid="talk-me-leaderboard-toggle"
          onChange={async (e) => { try { await api.patch("/talk/me", { leaderboard_opt_in: e.target.checked }); await reloadMe(); } catch (err) { tkErr(err); } }} />
      </label>
      <section className="rounded-3xl border border-white/10 p-4">
        <h2 className="font-heading font-black text-lg">Call & message alerts</h2>
        <p className="text-xs text-white/50 mb-3">Turn on push so incoming calls and messages ring your phone even when Jixxeo Talk is closed. Calls and messages use the “Messages” setting.</p>
        <PushPreferences />
      </section>
    </div>
  );
}
